/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SchoolInfo } from '../model/schoolInfo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MSMTService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Fetch organization data from MSMT registry by RED_IZO
     * Public endpoint to query the Czech Ministry of Education registry (RSSZ) to retrieve organization details, addresses, and facilities by RED_IZO identifier. No authentication required.
     * @param redIzo RED_IZO identifier (Resortní identifikátor právnické osoby)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public msmtDataRetrieve(redIzo: string, observe?: 'body', reportProgress?: boolean): Observable<SchoolInfo>;
    public msmtDataRetrieve(redIzo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SchoolInfo>>;
    public msmtDataRetrieve(redIzo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SchoolInfo>>;
    public msmtDataRetrieve(redIzo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (redIzo === null || redIzo === undefined) {
            throw new Error('Required parameter redIzo was null or undefined when calling msmtDataRetrieve.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (redIzo !== undefined && redIzo !== null) {
            queryParameters = queryParameters.set('red_izo', <any>redIzo);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SchoolInfo>('get',`${this.basePath}/msmt-data/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
